import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import ChevronRight16 from '@carbon/icons-react/es/chevron--right/16';
import { Select } from '@rocketlane/ui';
import { useState } from 'react';
import { components as RsComponents, defaultTheme } from 'react-select';
import styled from 'styled-components';
const Line = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-02);
`;
const Label = styled.span`
  padding: 0;
  margin-left: var(--spacing-03);
`;
const StyledGroup = styled(RsComponents.Group).attrs({
    theme: {
        ...defaultTheme
    }
})`
  padding-bottom: 0;
`;
export const GroupComponentForSelect = (props)=>{
    const { children, label, ...rest } = props;
    const [isVisible, setIsVisible] = useState(true);
    const toggleState = ()=>{
        setIsVisible((prev)=>!prev);
    };
    return /*#__PURE__*/ _jsx(StyledGroup, {
        ...rest,
        label: /*#__PURE__*/ _jsxs(Line, {
            onClick: toggleState,
            children: [
                isVisible ? /*#__PURE__*/ _jsx(ChevronDown16, {}) : /*#__PURE__*/ _jsx(ChevronRight16, {}),
                /*#__PURE__*/ _jsx(Label, {
                    children: label
                })
            ]
        }),
        children: isVisible && children
    });
};
export const GroupSelect = ({ options, ...rest })=>{
    return /*#__PURE__*/ _jsx(Select, {
        classNamePrefix: "ozone-select",
        options: options,
        components: {
            Group: GroupComponentForSelect
        },
        ...rest
    });
};
